// extracted by mini-css-extract-plugin
export var coliPad = "seamlessIntegration-module--coliPad--1d9e8";
export var coliPadHalf = "seamlessIntegration-module--coliPadHalf--14ed8";
export var mobileAddMore = "seamlessIntegration-module--mobileAddMore--e1d88";
export var moreCard = "seamlessIntegration-module--moreCard--baa1a";
export var seamlessCard = "seamlessIntegration-module--seamlessCard--c6d59";
export var seamlessRow = "seamlessIntegration-module--seamlessRow--037f2";